import config from "config/API";

function getFullLinkIcon(iconname) {
  return config.API_ICONS + "/" + iconname;
}

export {getFullLinkIcon};